(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function() {
    var containers = document.querySelectorAll('[data-collapsible-collection-description="true"]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      var content = container.querySelector('.text-block__content');
      var showMore = container.querySelector('#collapsible-description-show-more');
      var showLess = container.querySelector('#collapsible-description-show-less');

      if (!content || !showMore || !showLess) return;

      // Stato iniziale: collassato => mostra solo "Leggi tutto"
      var isCollapsed = container.getAttribute('data-collapsed') !== 'false';
      if (isCollapsed) {
        showMore.hidden = false;
        showLess.hidden = true;
        showMore.setAttribute('aria-expanded', 'false');
        showLess.setAttribute('aria-expanded', 'false');
      } else {
        showMore.hidden = true;
        showLess.hidden = false;
        showMore.setAttribute('aria-expanded', 'true');
        showLess.setAttribute('aria-expanded', 'true');
      }

      showMore.addEventListener('click', function() {
        container.setAttribute('data-collapsed', 'false');
        showMore.hidden = true;
        showLess.hidden = false;
        showMore.setAttribute('aria-expanded', 'true');
        showLess.setAttribute('aria-expanded', 'true');
      });

      showLess.addEventListener('click', function() {
        container.setAttribute('data-collapsed', 'true');
        showMore.hidden = false;
        showLess.hidden = true;
        showMore.setAttribute('aria-expanded', 'false');
        showLess.setAttribute('aria-expanded', 'false');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
